import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var showErrorToast = function (error, setSeeToastFunction, tl, showMessageApi) {
    if (!error)
        return;
    var message = "Hubo inconvenientes al procesar la solicitud, por favor contacte con la aseguradora";
    if (error.errors && Array.isArray(error.errors) && error.errors.length > 0) {
        if (showMessageApi) {
            message = error.errors.map(function (err) { return err.message; }).join("\n");
        }
        else {
            message = error.errors
                .map(function (err) { return tl("errors.".concat(err.message)); })
                .join("\n");
        }
    }
    else if (showMessageApi && error.message) {
        message = error.message;
    }
    setSeeToastFunction({
        show: true,
        message: message,
        type: typeAlert.error,
    });
    error.errors = [];
};
